import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import axios from 'axios';

export default function RSSFeed({ url }) {

 const [items, setItems] = useState([]);

 const loadItems = async () => {
 	
 	const { data } = await axios.get(url);
 	
 	const xml = new DOMParser().parseFromString(data, "text/xml");
 	const media = Array.from(xml.querySelectorAll("item")).map(item => ({
 	  title: item.querySelector("title").textContent,
 	  description: item.querySelector("description").textContent
 	}));
 	setItems(media.slice(0,3));
 }

 const renderFeedItems = () => {
 	return items.map((item, idx) => {
 	  return (<div key={`${idx}-rss`}>
      <div className="text-xl font-bold font-underline">{ item.title }</div>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.description)}} />
    </div>)
 	});
 }

 useEffect(() => {
   loadItems();
 }, [])

 return (
   <>
  { items && items.length ? renderFeedItems() : <></> }
  </>
 )

}